// @ts-nocheck
import { reportsInitialApi as api } from './initialApi';
export const addTagTypes = [
  'reports-controller',
  'report-schedules-controller',
  'user-report-filters-controller',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      updateReportMetadata: build.mutation<
        UpdateReportMetadataApiResponse,
        UpdateReportMetadataApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-10-21/metadata/${queryArg.reportId}`,
          method: 'PUT',
          body: queryArg.reportMetadataRequestBodyDto,
        }),
        invalidatesTags: ['reports-controller'],
      }),
      createSchedule: build.mutation<
        CreateScheduleApiResponse,
        CreateScheduleApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-10-01/schedules`,
          method: 'POST',
          body: queryArg.createScheduleRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['report-schedules-controller'],
      }),
      testRunSchedule: build.mutation<
        TestRunScheduleApiResponse,
        TestRunScheduleApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-10-01/schedules/${queryArg.scheduleId}/runs`,
          method: 'POST',
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['report-schedules-controller'],
      }),
      adminExportReportCsv: build.mutation<
        AdminExportReportCsvApiResponse,
        AdminExportReportCsvApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-02-24/${queryArg.reportType}/export-csv`,
          method: 'POST',
          body: queryArg.reportExportRequestBodyDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['reports-controller'],
      }),
      createOrUpdateUserReportFilters: build.mutation<
        CreateOrUpdateUserReportFiltersApiResponse,
        CreateOrUpdateUserReportFiltersApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-12-16/user-filters/save`,
          method: 'POST',
          body: queryArg.userDefinedFilterDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['user-report-filters-controller'],
      }),
      exportReport: build.mutation<ExportReportApiResponse, ExportReportApiArg>(
        {
          query: (queryArg) => ({
            url: `/2025-10-21/${queryArg.reportType}/export`,
            method: 'POST',
            body: queryArg.reportExportRequestBodyDto,
            headers: {
              'cs-organization': queryArg['cs-organization'],
              'cs-fleet': queryArg['cs-fleet'],
            },
          }),
          invalidatesTags: ['reports-controller'],
        }
      ),
      exportReportCsv: build.mutation<
        ExportReportCsvApiResponse,
        ExportReportCsvApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-10-21/${queryArg.reportType}/export-csv`,
          method: 'POST',
          body: queryArg.reportExportRequestBodyDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['reports-controller'],
      }),
      createReportMetadata: build.mutation<
        CreateReportMetadataApiResponse,
        CreateReportMetadataApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-10-21/metadata`,
          method: 'POST',
          body: queryArg.reportMetadataRequestBodyDto,
        }),
        invalidatesTags: ['reports-controller'],
      }),
      getFilterData: build.query<GetFilterDataApiResponse, GetFilterDataApiArg>(
        {
          query: (queryArg) => ({
            url: `/2025-12-16/user-filters/${queryArg.userId}`,
            headers: {
              'cs-organization': queryArg['cs-organization'],
              'cs-fleet': queryArg['cs-fleet'],
            },
          }),
          providesTags: ['user-report-filters-controller'],
        }
      ),
      getReports: build.query<GetReportsApiResponse, GetReportsApiArg>({
        query: (queryArg) => ({
          url: `/2025-10-21/report-types`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['reports-controller'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as reportsApi };
export type UpdateReportMetadataApiResponse =
  /** status 200 Request was successful. */ GmResponseCommon;
export type UpdateReportMetadataApiArg = {
  /** The report Id for the report to update. */
  reportId: string;
  reportMetadataRequestBodyDto: ReportMetadataRequestBodyDto;
};
export type CreateScheduleApiResponse =
  /** status 201 Schedule created */ GmResponseCommonScheduleResponse;
export type CreateScheduleApiArg = {
  /** Organization ID the schedule belongs to. */
  'cs-organization': string;
  /** Fleet ID of the caller. Without it the schedule is owned at organization scope. */
  'cs-fleet'?: string;
  createScheduleRequest: CreateScheduleRequest;
};
export type TestRunScheduleApiResponse =
  /** status 202 Run queued */ GmResponseCommonTestRunResponse;
export type TestRunScheduleApiArg = {
  /** Schedule ID */
  scheduleId: string;
  /** Organization ID the schedule belongs to. */
  'cs-organization': string;
};
export type AdminExportReportCsvApiResponse =
  /** status 200 Request was successful. */ Blob;
export type AdminExportReportCsvApiArg = {
  /** The report type to export. Must be SAFETY_EVENTS or TRIP_HISTORY. */
  reportType: string;
  /** Organization ID to scope the report data. */
  'cs-organization': string;
  reportExportRequestBodyDto: ReportExportRequestBodyDto;
};
export type CreateOrUpdateUserReportFiltersApiResponse =
  /** status 200 Request was successful. */ GmResponseCommon;
export type CreateOrUpdateUserReportFiltersApiArg = {
  /** Organization ID that the Fleet Manager belongs to. */
  'cs-organization': string;
  /** Fleet ID that the Fleet Manager belongs to. */
  'cs-fleet'?: string;
  userDefinedFilterDto: UserDefinedFilterDto;
};
export type ExportReportApiResponse =
  /** status 200 Request was successful. */ object;
export type ExportReportApiArg = {
  /** The report type to export for the given report type. */
  reportType: string;
  /** Organization ID that the Fleet Manager belongs to. */
  'cs-organization': string;
  /** Fleet ID that the Fleet Manager belongs to. */
  'cs-fleet'?: string;
  reportExportRequestBodyDto: ReportExportRequestBodyDto;
};
export type ExportReportCsvApiResponse =
  /** status 200 Request was successful. */ Blob;
export type ExportReportCsvApiArg = {
  /** The report type to export for the given report type. */
  reportType: string;
  /** Organization ID that the Fleet Manager belongs to. */
  'cs-organization': string;
  /** Fleet ID that the Fleet Manager belongs to. */
  'cs-fleet'?: string;
  reportExportRequestBodyDto: ReportExportRequestBodyDto;
};
export type CreateReportMetadataApiResponse =
  /** status 200 Request was successful. */ GmResponseCommon;
export type CreateReportMetadataApiArg = {
  reportMetadataRequestBodyDto: ReportMetadataRequestBodyDto;
};
export type GetFilterDataApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonListUserDefinedFilterDto;
export type GetFilterDataApiArg = {
  /** user id */
  userId: string;
  /** Organization ID that the Fleet Manager belongs to. */
  'cs-organization': string;
  /** Fleet ID that the Fleet Manager belongs to. */
  'cs-fleet'?: string;
};
export type GetReportsApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonListReportDescriptionDto;
export type GetReportsApiArg = {
  /** Organization ID that the Fleet Manager belongs to. */
  'cs-organization': string;
  /** Fleet ID that the Fleet Manager belongs to. */
  'cs-fleet'?: string;
};
export type GmResponseError = {
  errorType: 'GENERIC' | 'VALIDATION';
  errorCode: string;
  message: string;
};
export type GmResponseCommon = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FetchingMetadataDto = {
  /** Type of report (e.g., TRIP_HISTORY, SAFETY_EVENTS) */
  type?: string;
  /** API version used for fetching the report data */
  apiVersion?: string;
};
export type ReportMetadataRequestBodyDto = {
  /** Unique identifier for the report. Required for updates, optional for creates */
  reportId?: string;
  /** Metadata about how the report data is fetched */
  fetchingMetadata?: FetchingMetadataDto;
  /** Display name of the report */
  name?: string;
  /** Detailed description of the report */
  description?: string;
  /** Set of supported filter types for this report */
  supportedFilterTypes?: string[];
};
export type RecurrenceDto = {
  /** DAILY, WEEKLY or MONTHLY */
  frequency?: string;
  /** Hour of the day, 0-23 */
  hourOfDay?: number;
  /** Required for WEEKLY, MONDAY to SUNDAY */
  dayOfWeek?: string;
  /** MONTHLY only, 1-31; exclusive with lastDayOfMonth */
  dayOfMonth?: number;
  /** MONTHLY only; exclusive with dayOfMonth */
  lastDayOfMonth?: boolean;
};
export type ScheduleFilters = {
  fleetIds: string[];
  vehicleIds: string[];
  driverIds: string[];
};
export type ScheduleResponse = {
  id: string;
  name: string;
  reportType:
    | 'TRIP_HISTORY'
    | 'SAFETY_EVENTS'
    | 'HOME_CHARGING'
    | 'UTILIZATION'
    | 'UNKNOWN';
  recurrence: RecurrenceDto;
  timeZone: string;
  filters: ScheduleFilters;
  recipients: string[];
  recipientCount: number;
  nextRunAtUtc: string;
  ownerProfileId: string;
  isOwner: boolean;
  canManage: boolean;
  createdAt: string;
  updatedAt: string;
};
export type GmResponseCommonScheduleResponse = {
  result?: ScheduleResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FiltersDto = {
  fleetIds?: string[];
  vehicleIds?: string[];
  driverIds?: string[];
};
export type CreateScheduleRequest = {
  /** Schedule name, at most 100 characters */
  name?: string;
  /** TRIP_HISTORY, SAFETY_EVENTS, HOME_CHARGING or UTILIZATION */
  reportType?: string;
  recurrence?: RecurrenceDto;
  filters?: FiltersDto;
  /** Email addresses that receive the report */
  recipients?: string[];
};
export type TestRunResponse = {
  /** {scheduleId}:{scheduledForUtc}; also the Service Bus message ID */
  runId: string;
  scheduledForUtc: string;
};
export type GmResponseCommonTestRunResponse = {
  result?: TestRunResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ReportFiltersDto = {
  /** Organization ID to filter the report data. If provided, must match the cs-organization header value; the header value is always used for the query. */
  orgId?: string;
  /** List of fleet IDs to filter the report data */
  fleetIds?: string[];
  /** List of driver IDs to filter the report data */
  driverIds?: string[];
  /** List of vehicle IDs to filter the report data */
  vehicleIds?: string[];
  /** Start date for the report data range in ISO 8601 UTC format. If not provided, defaults to 30 days ago. */
  fromDate?: string;
  /** End date for the report data range in ISO 8601 UTC format. If not provided, defaults to current date/time. */
  toDate?: string;
  /** User time zone in ISO 8601 format */
  userTimeZone?: string;
};
export type UserPreferencesDto = {
  /** Locale identifier for formatting (e.g., en-US, fr-FR) */
  locale: string;
  /** User time zone identifier (e.g., 'America/Los_Angeles') */
  timeZone: string;
  /** Deprecated. Ignored. Use distanceUnit, temperatureUnit, fuelConsumptionUnit, and energyConsumptionUnit. */
  unitSystem?: 'METRIC' | 'IMPERIAL' | 'US_CUSTOMARY';
  /** Distance unit (MeasurementUnit code, e.g. KILOMETER, MILE). */
  distanceUnit: string;
  /** Temperature unit (e.g. CELSIUS, FAHRENHEIT). Used by Home Charge. */
  temperatureUnit: string;
  /** Fuel-consumption unit (e.g. KILOMETER_PER_LITER, MILE_PER_GALLON_US). */
  fuelConsumptionUnit: string;
  /** Energy-consumption unit (e.g. WATT_HOUR_PER_KILOMETER, WATT_HOUR_PER_MILE). */
  energyConsumptionUnit: string;
};
export type ReportExportRequestBodyDto = {
  /** Filters to apply when exporting the report */
  filters: ReportFiltersDto;
  /** User preferences for locale, time zone, and units. locale, timeZone, distanceUnit, temperatureUnit, fuelConsumptionUnit, and energyConsumptionUnit are required. */
  userPreferences: UserPreferencesDto;
};
export type UserDefinedFilterDto = {
  /** User ID to filter the filter data */
  userId: string;
  /** Filters applied when generating the report */
  filters: FiltersDto;
};
export type GmResponseCommonListUserDefinedFilterDto = {
  result?: UserDefinedFilterDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ReportDescriptionDto = {
  /** The type of report (e.g., TRIP_HISTORY, SAFETY_EVENTS, HOME_CHARGING, UTILIZATION) */
  reportType?: string;
  /** Display name of the report */
  name?: string;
  /** Detailed description of what the report contains */
  description?: string;
};
export type GmResponseCommonListReportDescriptionDto = {
  result?: ReportDescriptionDto[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export const {
  useUpdateReportMetadataMutation,
  useCreateScheduleMutation,
  useTestRunScheduleMutation,
  useAdminExportReportCsvMutation,
  useCreateOrUpdateUserReportFiltersMutation,
  useExportReportMutation,
  useExportReportCsvMutation,
  useCreateReportMetadataMutation,
  useGetFilterDataQuery,
  useGetReportsQuery,
} = injectedRtkApi;
